<template>
  <div :class="containerClass" @keyup.enter.native="handleLogin">
    <img :src="logoPng" class="logo" />
    <div class="title">{{titleName}}</div>
    <!-- <div class="login-left">
        <div class="login-time">
          {{time}}
        </div>
        <img class="img" src="/img/logo.png" alt="">
        <p class="title">{{ $t('login.info') }}</p>
      </div> -->
    <!-- <div class="login-border">   -->
    <!-- <div class="login-main"> -->
    <!-- <h4 class="login-title">登录</h4> -->
    <userLogin v-if="activeName === 'user'" class="login"></userLogin>
    <!-- <codeLogin v-else-if="activeName === 'code'"></codeLogin> -->
    <!-- <thirdLogin v-else-if="activeName === 'third'"></thirdLogin> -->
    <!-- <div class="login-menu"> -->
    <!-- <a href="#" @click.stop="activeName = 'user'">{{
            $t("login.userLogin")
          }}</a> -->
    <!-- <a href="#" @click.stop="activeName='code'">{{ $t('login.phoneLogin') }}</a> -->
    <!-- <a href="#" @click.stop="activeName = 'third'">{{
            $t("login.thirdLogin")
          }}</a> -->
    <!-- </div> -->
  </div>
  <!-- </div> -->
  <!-- </div> -->
</template>
<script>
import userLogin from "./userlogin";
import codeLogin from "./codelogin";
import thirdLogin from "./thirdlogin";
import { mapGetters } from "vuex";
import { dateFormat } from "@/util/date";
import { validatenull } from "@/util/validate";
import topLang from "@/page/index/top/top-lang";
import topColor from "@/page/index/top/top-color";
import { getQueryString, getTopUrl } from "@/util/util";
import urlSettings from '@/config/url-settings.js';
import { info } from "@/api/system/tenant";
export default {
  name: "login",
  components: {
    userLogin,
    codeLogin,
    thirdLogin,
    topLang,
    topColor,
  },
  data() {
    return {
      containerClass:'container',
      titleName:'',
      logoPng:'/img/logo.png',
      time: "",
      activeName: "user",
      socialForm: {
        tenantId: "",
        source: "",
        code: "",
        state: "",
      },
    };
  },
  watch: {
    $route() {
      this.handleLogin();
    },
  },
  created() {
    this.handleLogin();
    this.getTime();
    //  let url = window.location.host;
     this.titleName = urlSettings.VUE_APP_TITLE_NAME;
     if(urlSettings.VUE_APP_ENV_NAME.indexOf('demo') > -1){
        this.containerClass = 'container123';
        this.logoPng = '/img/pms1/logo.png';
     }else{
       if(urlSettings.VUE_APP_PROJECT_NAME=='crmedical'){
          this.containerClass = 'container';
          this.logoPng = '/img/logo.png';
       }else if(urlSettings.VUE_APP_PROJECT_NAME=='v4ward'){
          this.containerClass = 'container123';
          this.logoPng = '/img/pms1/logo.png';
       }else{
         this.containerClass = 'container123';
          this.logoPng = '';
       }

     }
    // if(url=='www.hre-test.pms1.cn' || url=='hre-test.pms1.cn' || url.indexOf('hre-test.pms1')>-1){
    //   this.containerClass = 'container';
    //   this.logoPng = '/img/logo.png';
    // }else if(url=='www.hre.winsyun.com' || url=='hre.winsyun.com' || url.indexOf('hre.winsyun')>-1){
    //   this.containerClass = 'container';
    //   this.logoPng = '/img/logo.png';
    // }else if(url=='www.hre.pms1.cn' || url=='hre.pms1.cn' || url.indexOf('hre.pms1')>-1){
    //   this.containerClass = 'container123';
    //   this.logoPng = '/img/pms1/logo.png';
    // }else if(url=='localhost:1888' || url.indexOf('localhost:1888')>-1){
    //   this.containerClass = 'container123';
    //   this.logoPng = '/img/pms1/logo.png';
    // }else{
    //   this.containerClass = 'container123';
    //   this.logoPng = '/img/pms1/logo.png';
    // }
  },
  mounted() {},
  computed: {
    ...mapGetters(["website", "tagWel"]),
  },
  props: [],
  methods: {
    getTenant() {
      let domain = getTopUrl();
      if(urlSettings.TENANTID){
        this.tenantMode = false;
        this.socialForm.tenantId = urlSettings.TENANTID;
      }else{
        this.$message.error(`该域名【${domain}】未配置，请尽快联系管理员！`);
      }
      
    },
    getTime() {
      setInterval(() => {
        this.time = dateFormat(new Date());
      }, 1000);
    },
    handleLogin() {
      const topUrl = getTopUrl();
      console.log('topUrl==>',topUrl);
      const redirectUrl = "/oauth/redirect/";
      this.socialForm.source = getQueryString("source");
      this.socialForm.code = getQueryString("code");
      this.socialForm.state = getQueryString("state");
      if (
        validatenull(this.socialForm.source) &&
        topUrl.includes(redirectUrl)
      ) {
        let source = topUrl.split("?")[0];
        source = source.split(redirectUrl)[1];
        this.socialForm.source = source;
      }
      if (
        !validatenull(this.socialForm.source) &&
        !validatenull(this.socialForm.code) &&
        !validatenull(this.socialForm.state)
      ) {
        const loading = this.$loading({
          lock: true,
          text: "第三方系统登录中,请稍后。。。",
          spinner: "el-icon-loading",
        });
        console.log('LoginBySocial==>',);
        this.$store
          .dispatch("LoginBySocial", this.socialForm)
          .then(() => {
            window.location.href = topUrl.split(redirectUrl)[0];
            this.$router.push({ path: this.tagWel.value });
            loading.close();
          })
          .catch(() => {
            loading.close();
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/login.scss";
// .login-container {
//   background-color: #fff;
// }
.container {
  position: relative;
  background-color: #eee;
  padding-top: 14vh;
  height: 100vh;
  box-sizing: border-box;
  background: no-repeat center url("/img/bg.jpg");
  background-size: cover;
  .logo {
    position: absolute;
    width: 220px;
    top: 2px;
    left: 2px;
  }
  .title {
    width: 100%;
    font-weight: bold;
    font-size: 40px;
    letter-spacing: 10px;
    text-align: center;
    color: #fff;
  }
}
.container123 {
  position: relative;
  background-color: #eee;
  padding-top: 14vh;
  height: 100vh;
  box-sizing: border-box;
  background: no-repeat center url("/img/pms1/bg.jpg");
  background-size: cover;
  .logo {
    position: absolute;
    // width: 220px;
    top: 2px;
    left: 2px;
  }
  .title {
    width: 100%;
    font-weight: bold;
    font-size: 40px;
    letter-spacing: 10px;
    text-align: center;
    color: #fff;
  }
}
.login {
  width: 30vw;
  background-color: #fff;
  border-radius: 5px;
  margin: 9vh auto;
}
</style>
